import { Controller } from '@hotwired/stimulus'
import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

// Flowbite の Carousel（data-carousel="slide"）を置き換える、Swiperベースの
// 自動再生スライドショー実装（issue #2203 Phase 3）。
// Flowbite Carousel のデフォルト挙動（3秒間隔の自動再生・無限ループ、
// ナビゲーション/ページネーション/手動スワイプなし）を再現する。
// Flowbite版はタッチ/ドラッグ操作を一切実装していなかったため、
// Swiperのデフォルト（allowTouchMove: true）のままだと新たに手動操作が
// 可能になってしまう。allowTouchMove: false で無効化し挙動を揃える。
//
// 画像枚数表示（.orderNumber内の.no要素）について:
// front.scssに `.orderNumber .no[aria-current="true"] { display: block }`
// というルールがあり、aria-current="true"が付いた.noだけが表示される。
// HAML側は全.noにaria-current="true"を静的に付けており、Flowbite本家の
// Carousel._setActiveItem()がアクティブなスライドのインジケーターにのみ
// aria-current="true"を残し、他は"false"に補正することで初めて正しく
// 1つだけ表示されていた。Swiperはこの補正を行わないため、ここで
// アクティブなスライドに対応する.noのみaria-current="true"にする。
//
// Turboキャッシュとloopモードのスライド並び替えについて:
// Swiperのloopモードは`.swiper-slide`をDOM上で実際にprepend/appendして
// 並び替える（`swiper.js`のloopFix参照）。この並び替えは`swiper.destroy()`
// が呼ぶ`loopDestroy()`で元の順序に復元されるが、Turboは`turbo:before-cache`
// でページスナップショットを取得するのに対し、Stimulusの`disconnect()`は
// 新ページ描画後まで発火しない。そのため何もしないと並び替え途中のDOMが
// キャッシュされ、戻る操作での復元時にキービジュアルの表示順とカウンター
// 表示がずれる。`turbo:before-cache`時点で明示的にdestroy()しておく。
export default class extends Controller {
  connect() {
    const slideCount = this.element.querySelectorAll('.swiper-slide').length
    this.indicatorEls = Array.from(this.element.querySelectorAll('.orderNumber .no'))

    this.swiper = new Swiper(this.element, {
      modules: [Autoplay],
      allowTouchMove: false,
      // 画像が1枚以下の場合、loop/autoplayを渡すとSwiperがコンソールに
      // 警告を出す（動作に支障はないが不要なノイズのため回避する）
      loop: slideCount > 1,
      autoplay:
        slideCount > 1
          ? {
              delay: 3000,
              disableOnInteraction: false,
            }
          : false,
      on: {
        init: (swiper) => this.updateIndicators(swiper),
        slideChange: (swiper) => this.updateIndicators(swiper),
      },
    })

    this.destroySwiper = this.destroySwiper.bind(this)
    document.addEventListener('turbo:before-cache', this.destroySwiper)
  }

  updateIndicators(swiper) {
    this.indicatorEls.forEach((el, index) => {
      el.setAttribute('aria-current', index === swiper.realIndex ? 'true' : 'false')
    })
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.destroySwiper)
    this.destroySwiper()
  }

  destroySwiper() {
    this.swiper?.destroy()
    this.swiper = null
  }
}
